import { Box } from '@medly-components/core';
import styled from 'styled-components';
import { TimelineWrapper } from '../../../Station.styled';
import { ClearIcon } from '@medly-components/icons';

export const SubZoneBackgroundWrapper = styled(Box)`
    position: absolute;
    background: transparent;
    padding: 0;
`;

export const SubZoneBackground = styled(Box)<{ xPosition: number }>`
    position: relative;
    width: 100%;
    height: 100%;
    background-color: ${({ theme }) => theme.colors.white};
    border: 0.15rem dashed ${({ theme }) => theme.colors.royalBlue[500]};
    border-radius: 0.8rem;
    padding: 0;

    &::before {
        transform: translateY(-50%);
        content: '';
        position: absolute;
        left: ${({ xPosition }) => `${xPosition - 4}px`};
        width: 4rem;
        height: 0.8rem;
        z-index: 0;
        background-color: ${({ theme }) => theme.colors.white};
        border: 0.15rem dashed ${({ theme }) => theme.colors.royalBlue[500]};
        top: -4px;
        border-radius: 1rem 1rem 0 0;
        border-bottom: 0;
    }
`;

export const SubZoneTimelineWrapper = styled(TimelineWrapper)`
    padding: 0.4rem 1.2rem;
    z-index: 1;
`;

export const CloseIcon = styled(ClearIcon)`
    position: absolute;
    top: 1.6rem;
    right: 1.6rem;
    z-index: 1;
`;
